<template>
  <div class="embed-form">
    <label for="embed_name">Name</label>
    <input type="text" id="embed_name" v-model="title" v-on:blur="updateField('title', $event)" />
    <label for="embed_url">URL</label>
    <input type="text" id="embed_url" v-model="URL" v-on:blur="updateField('URL', $event)" />
    <label for="embed_name">Payload [key, value]</label>
    <ul>
      <li v-for="(option, index) in payload" :key="'option-' + index">
        <div @click="deleteOption(index)" class="delete__icon" >
          <i class="material-icons">delete_forever</i>
        </div>
        <label :for="'embed_option_key' + index">Key Name</label>
        <input :name="'embed_option_key' + index" type="text" v-model="option.key" v-on:blur="updateOptionProperty(index, 'key', option.key)" />
        <label :for="'embed_option_value' + index">Value</label>
        <textarea :id="'embed_option_value' + index" type="text" v-model="option.value" v-on:blur="updateOptionProperty(index, 'value', option.value)" />
      </li>
    </ul>
    <a class="icon-button" href="#" v-on:click.prevent="onNewOption()">
      <i class="material-icons">add</i>
    </a>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'embed-form',
  props: ['tag'],
  created() {
    console.log('embed form created', this.tag)
    this.title = this.tag.meta.title
    this.URL = this.tag.meta.URL
    this.payload = this.tag.payload || []
  },
  data() {
    return {
      title: null,
      URL: null,
      payload: null
    }
  },
  components: {
  },
  computed: {
    ...mapState(['selection']),
    ...mapGetters(['currentTime'])
  },
  methods: {
    ...mapMutations(['updateEmbed', 'setPlayerTime']),
    updateField(field, eventOrValue) {
      this[field] = eventOrValue.target ? eventOrValue.target.value : eventOrValue
      this.updateTagEmbed()
    },
    updateOptionProperty(index, prop, value) {
      console.log('updateOptionProperty', index, prop, value)
      // this.payload[index][prop] = value
      this.updateTagEmbed()
    },
    updateTagEmbed() {
      const { title, URL, payload } = this
      console.log('updateTagEmbed', title, payload)
      // todo mutation
      this.updateEmbed({ title, URL, payload })
    },
    deleteOption(i) {
      this.payload.splice(i, 1)
      this.updateTagEmbed()
    },
    onNewOption() {
      this.payload.push({
        key: 'key',
        value: 'value'
      })
    }
  }
}

</script>
